import React, { ReactElement } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { ApplicationState } from 'reducers';
import { connect, DispatchProp } from 'react-redux';
import { UserAllDataFragment } from '@api/graphql/types';
import ReactTooltip from 'react-tooltip';
import ToastManager from './ToastManager';
import Navigation from './Navigation';
import Footer from './Footer';
// import Header from './Header';
import Subheader from './Subheader';

type Props = {
    user: UserAllDataFragment | null,
    permissions: string[] | null,
    headerButton?: ReactElement<any>,
} & DispatchProp<any> & RouteComponentProps;

class Drawer extends React.Component<Props> {

    public componentDidUpdate() {
        ReactTooltip.rebuild();
    }

    public render() {
        const { children, user } = this.props;
        if (!user) {
            return children;
        }

        return (
            <div id="wrapper">
                <Navigation />
                <div id="page-wrapper" className="gray-bg">
                    {/*<Header />*/}

                    <Subheader headerButton={this.props.headerButton} />

                    <div className="wrapper wrapper-content animated fadeIn">
                        {this.props.children}
                        <ReactTooltip place="top" type="dark" effect="solid"/>
                    </div>
                    <Footer />
                </div>
                <ToastManager />
            </div >
        );
    }
}

const mapStateToProps = ({ auth }: ApplicationState) => {
    return {
        user: auth.user,
        permissions: auth.permissions,
    };
};

export default withRouter(connect(mapStateToProps)(Drawer));



// WEBPACK FOOTER //
// ./src/components/Drawer.tsx